module.exports = __webpack_public_path__ + "static/media/my_reports.e6e8a39c.png";